import React from "react"

import { SubscriptionPlanPicker } from "@/components/Billing/SubscriptionPlanPicker"
import { cn } from "@/lib/utils"
import { trackDemoEntryAnalysisEvent } from "@/utils/demoEntryAnalysisAnalytics"
import { AUTH_FONT } from "./DemoEntryAnalysisShell"

export function DemoResultsPricingSection(props: {
  sectionRef?: React.Ref<HTMLElement>
  surface: string
  className?: string
  headingId?: string
}): React.ReactElement {
  const { sectionRef, surface, className, headingId = "demo-results-pricing-heading" } = props

  return (
    <section
      ref={sectionRef}
      data-demo-results-pricing=""
      aria-labelledby={headingId}
      className={cn("w-full scroll-mt-4", className)}
    >
      <h2
        id={headingId}
        data-demo-results-pricing-heading=""
        className={cn(
          AUTH_FONT,
          "mb-10 text-center text-4xl font-normal leading-tight sm:text-5xl md:text-6xl",
          "bg-[image:var(--gradient-primary)] bg-clip-text text-transparent"
        )}
      >
        Unlock the full Tessera platform
      </h2>
      <div data-paywall-plan-picker="" className="w-full min-w-0">
        <SubscriptionPlanPicker
          forceMarketingLaunchOffer
          onPlanCheckoutClick={(planId) => {
            trackDemoEntryAnalysisEvent("subscribe_nudge_clicked", {
              surface,
              plan: planId,
            })
          }}
        />
      </div>
    </section>
  )
}
